import { useIsMounted } from "./useIsMounted";
import useWindowDimensions from "./useWindowDimensions";

export const useRenderDevice = (limit) => {
  const isMounted = useIsMounted();
  const { width } = useWindowDimensions();
  let isDeviceRender;
  if (limit["min"]) {
    isDeviceRender = width > limit.min;
  } else isDeviceRender = width < limit.max;
  const isRender = isMounted && isDeviceRender;

  return isRender;
};
